import { render, staticRenderFns } from "./buyCertificate.vue?vue&type=template&id=0c633172&scoped=true&lang=true"
import script from "./buyCertificate.vue?vue&type=script&lang=js"
export * from "./buyCertificate.vue?vue&type=script&lang=js"
import style0 from "./buyCertificate.vue?vue&type=style&index=0&id=0c633172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c633172",
  null
  
)

export default component.exports